//* 배송사진 모달 (flat FlowerStatItem 데이터 기반)
import { FC, useMemo } from 'react';

import { FlowerStatItem } from '@shared/api/flowerStat/flowerStat.interface';
import Modal from '@shared/components/Modal';
import { fileBucketUrl } from '@shared/utils/fileUtils';
import { Image as AntImage } from 'antd';

interface Props {
  openId: string;
  flowerStatItem?: FlowerStatItem;
}

export const DeliveredImageModal: FC<Props> = function DeliveredImageModal({
  openId,
  flowerStatItem,
}: Props) {
  const deliveredInfo = useMemo(() => {
    if (flowerStatItem) {
      return (
        <div className="grid grid-cols-auto-1fr gap-x-4 gap-y-1 rounded-md py-2 text-base font-bold">
          <p>보내는이</p>
          <p>{flowerStatItem.senderPhrase}</p>
          <p>조의문구</p>
          <p>{flowerStatItem.condolencePhrase}</p>
        </div>
      );
    }
  }, [flowerStatItem]);

  const imageRender = useMemo(() => {
    if (flowerStatItem?.deliveredImageUrl) {
      return (
        <AntImage
          src={fileBucketUrl(flowerStatItem.deliveredImageUrl, 'w1080')}
          preview={{
            src: fileBucketUrl(flowerStatItem.deliveredImageUrl, 'raw'),
          }}
        />
      );
    } else {
      return <p>사진준비중입니다.</p>;
    }
  }, [flowerStatItem?.deliveredImageUrl]);

  return (
    <Modal openId={openId} className="space-y-4">
      <div className="center-box w-full rounded-lg border theme-bg-8">
        {deliveredInfo}
      </div>
      <div className="center-box">{imageRender}</div>
    </Modal>
  );
};
